import React from 'react';
import images from '../../constants';
import styles from './Technologies.module.scss';

function Technologies() {
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>Technologies I speak:</h2>

      <ul className={styles.list}>
        <li className={styles.item}>
          <img src={images.reactBadge} alt="logo react" />
        </li>
        <li className={styles.item}>
          <img src={images.javascriptBadge} alt="logo javascript" />
        </li>
        <li className={styles.item}>
          <img src={images.htmlBadge} alt="logo html5" />
        </li>
        <li className={styles.item}>
          <img src={images.cssBadge} alt="logo css3" />
        </li>
      </ul>
    </section>
  );
}

export default Technologies;
